// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2OOhA","col":"styles_col__Utr4J"};